export default "__VITE_ASSET__BbtUa76O__"